import { render } from "./ColumnWidth.vue?vue&type=template&id=ad570f34&scoped=true&ts=true"
import script from "./ColumnWidth.vue?vue&type=script&lang=ts"
export * from "./ColumnWidth.vue?vue&type=script&lang=ts"

import "./ColumnWidth.vue?vue&type=style&index=0&id=ad570f34&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad570f34"]])

export default __exports__